// Public entry — exposes hls.js as window.Hls for inline <video> players
// in public landing views (e.g. /shield). Loaded on demand via @vite() in
// the specific blade view that uses HLS.
import Hls from 'hls.js';
window.Hls = Hls;
